import React, { useCallback, useEffect, useState } from "react";
import { Gift, Crown } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";

export const MembershipPanel = ({ customerId }) => {
  const [m, setM] = useState(null);
  const load = useCallback(() => api.get(`/customers/${customerId}/membership`)
    .then((r) => setM(r.data))
    .catch((e) => logError("Membership load failed", e)), [customerId]);
  useEffect(() => {
    if (customerId) load();
  }, [customerId, load]);

  const grant = async () => {
    try {
      await api.post("/rewards", { customer_id: customerId, notes: "Diberikan manual oleh admin" });
      toast.success("Reward sewa gratis ditambahkan");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
  };
  const cancel = async (id) => {
    try {
      await api.post(`/rewards/${id}/cancel`, { reason: "Dibatalkan admin" });
      toast.success("Reward dibatalkan"); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
  };

  if (!m) return null;
  return (
    <div data-testid="membership-panel">
      <div className="text-[11px] uppercase tracking-widest text-ink-soft mb-2">Membership &amp; Loyalty</div>
      <div className="grid sm:grid-cols-3 gap-2 text-xs">
        <div className="border border-black/10 rounded-md p-3">
          <div className="flex items-center gap-1.5 text-ink-soft"><Crown size={13} /> Tier</div>
          <div className="mt-1 font-semibold" data-testid="mp-tier">{m.tier?.name} · {m.tier?.discount_percent}%</div>
        </div>
        <div className="border border-black/10 rounded-md p-3">
          <div className="flex items-center gap-1.5 text-ink-soft"><Gift size={13} /> Progres reward</div>
          <div className="mt-1 font-semibold" data-testid="mp-progress">{m.loyalty?.progress} / {m.loyalty?.required}</div>
        </div>
        <div className="border border-black/10 rounded-md p-3">
          <div className="text-ink-soft">Hari gratis bulan ini</div>
          <div className="mt-1 font-semibold" data-testid="mp-wallet">{m.wallet?.days_left} / {m.wallet?.days_total}</div>
        </div>
      </div>
      <div className="mt-3 flex items-center justify-between gap-3">
        <span className="text-xs text-ink-soft">Reward: {m.rewards?.length || 0}</span>
        <button data-testid="grant-reward-btn" onClick={grant}
          className="h-8 px-3 rounded-md border border-black/15 text-xs hover:border-lm-red">+ Beri reward gratis</button>
      </div>
      <div className="mt-2 divide-y divide-black/5">
        {(m.rewards || []).map((r) => (
          <div key={r.id} className="py-1.5 flex items-center justify-between gap-3 text-xs" data-testid={`reward-${r.id}`}>
            <span>{r.type === "free_day" ? `Gratis ${r.days} hari` : r.type} · {r.source} · {(r.earned_at || "").slice(0, 10)}</span>
            <span className="flex items-center gap-2">
              <span className={`px-2 py-0.5 rounded-full border ${r.status === "Available" ? "bg-emerald-50 border-emerald-300 text-emerald-800" : "border-black/15 text-ink-soft"}`}>{r.status}</span>
              {r.status !== "Redeemed" && r.status !== "Cancelled" && (
                <button data-testid={`cancel-reward-${r.id}`} onClick={() => cancel(r.id)} className="text-ink-soft hover:text-lm-red">batalkan</button>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
